
const digest = 'a05822ff7cd049181d9be10284e801414519959d81844e96eb05aef5a22f6d41';
const classes = {"wrapper":"_wrapper_hmshh_1","list":"_list_hmshh_14"};
const css = `._wrapper_hmshh_1 {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px 12px 0;
  border: 1px solid #eaedf3;
  border-bottom: none;
  background-color: #fff;
  height: 100%;
  min-height: 0;
  font-family: "Rubik", sans-serif;
}

._list_hmshh_14 {
  flex: 1;
  min-height: 0;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  